// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__f-p4d","open":"loader_open__EamCS","content":"loader_content__mfAp-","close":"loader_close__MeKPp"};